import React from "react";
import ImgProductd1b9 from "../assets/BackOffice/UploadImage/Products/d1b9e9ad-3214-4b01-b7b9-577442731f9b.webp"
import ImgProduct557b from "../assets/BackOffice/UploadImage/Products/557b3154-feac-49c9-953c-e25e130ef4d2.webp"
import ImgProduct1518 from "../assets/BackOffice/UploadImage/Products/15182e99-33c6-4d41-837d-750963b6f4d8.webp"
import ImgProduct35fc from "../assets/BackOffice/UploadImage/Products/35fc9a46-37b5-4860-ad57-4b468145ccba.webp"
import ImgProduct7597 from "../assets/BackOffice/UploadImage/Products/7597affd-3ef7-44c8-96ec-37cb313537f6.webp"
import ImgProduct9da2 from "../assets/BackOffice/UploadImage/Products/9da20b05-4da0-4b4a-bb86-a530257dc1f7.webp"
import ImgKrediKartiIleTTS from "../assets/images/kredi-karti-ile-shell-tts.webp"
import ImgTTSFiloYonetimi from "../assets/images/filo-yonetim-new.jpg"
import TTSForm from "../components/common/TTSForm";
import PageTitle from "../assets/images/city-image-navigation.jpeg";
import { products } from "../data/products";


export default function Urunler() {
  return (
    <div className="container-fluid animate pageWrapper">
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>&#220;R&#220;NLER</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"}{" "}
                  <a href="#">&#220;R&#220;NLER</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>

        {/* <!--/pageTitle--> */}

        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  SHELL <b>YAKIT YÖNETİMİ</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row center-xs mt-3 mb-6">
              {/* <!--urun--> */}
              {products
                .filter((p) => p.type === "yakit")
                .map((p, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6 col-xm-12 col-xs-12" key={index} >
                    <div className="productBox">
                      <span className="Image">
                        <a href={p.link}>
                          <img src={p.img} />
                        </a>
                      </span>
                      <span className="productDescription">
                        <h3>{p.title}</h3>
                        <span>{p.subtitle}</span>
                        <p>{p.desc}</p>
                        <a href={p.link}>DETAYLI BİLGİ</a>
                      </span>
                    </div>
                  </div>
                ))}
              
              {/* <!--/urun--> */}
            </div>
            {/* <!--/urunler--> */}
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  SHELL <b>FİLO YÖNETİMİ</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row center-xs mt-3 mb-6">
              {/* <!--urun--> */}
              {products
                .filter((p) => p.type === "filo")
                .map((p, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6 col-xm-12 col-xs-12" key={index}>
                    <div className="productBox">
                      <span className="Image">
                        <a href={p.link}>
                          <img src={p.img} />
                        </a>
                      </span>
                      <span className="productDescription">
                        <h3>{p.title}</h3>
                        <span>{p.subtitle}</span>
                        <p>
                          {p.desc}
                        </p>
                        <a href={p.link}>
                          DETAYLI BİLGİ
                        </a>
                      </span>
                    </div>
                  </div>
                ))}
              {/* <div className="col-lg-4 col-md-6 col-sm-6 col-xm-12 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <a href="/urunler/hizli-gecis-sistemi-hgs">
                      <img src={ImgProduct1518} height="263" width="375" />
                    </a>
                  </span>
                  <span className="Content">
                    <h3>Hızlı Ge&#231;iş Sistemi (HGS)</h3>
                    <span>Shell Kurumsal HGS</span>
                    <p>
                      Şirket ara&#231;larınızın HGS ge&#231;işlerini Shell Taşıt
                      Tanıma Sistemi ile y&#246;netin. Sonradan &#246;deme
                      avantajından ve online raporlamadan yararlanın.
                    </p>
                    <a href="/urunler/hizli-gecis-sistemi-hgs">DETAYLI BİLGİ</a>
                  </span>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xm-12 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <a href="/urunler/kredi-karti-ile-shell-tasit-tanima">
                      <img src={ImgKrediKartiIleTTS} height="263" width="375" />
                    </a>
                  </span>
                  <span className="Content">
                    <h3>Kredi Kartı ile Shell TTS</h3>
                    <span>Shell Taşıt Tanıma Sistemi</span>
                    <p>
                      Shell Taşıt Tanıma Sistemi ile entegre kredi kartı
                      &#246;deme se&#231;eneği, &#246;n &#246;demesiz ve
                      blokesiz akaryakıt ikmali sağlamaktadır.
                    </p>
                    <a href="/urunler/kredi-karti-ile-shell-tasit-tanima">
                      DETAYLI BİLGİ
                    </a>
                  </span>
                </div>
              </div> */}
              {/* <!--/urun--> */}
            </div>
            
            {/* <!--/urunler--> */}
          </div>
        </div>
        {/* <!--/page--> */}
      </div>
    </div>
  );
}
